<div [formGroup]="form">
    <div class="section-container">
        <div class="row g-3">
            <div class="col-12 col-md-8">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Nome da regra</mat-label>
                    <input matInput type="text" formControlName="nome" maxlength="150">
                </mat-form-field>
            </div>
            <div class="col-12 col-md-4 d-flex align-items-center">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivo">Ativa</mat-slide-toggle>
            </div>
        </div>
    </div>
    
    <app-regra-tributaria-classificacao-tributaria-section
        [form]="classificacaoForm"
        [csts]="csts"
        [cclasstribs]="cclasstribs"
        [relacoes]="relacoes"
        [indicadoresDoacao]="indicadoresDoacao">
    </app-regra-tributaria-classificacao-tributaria-section>

    <app-regra-tributaria-modelos-documento-section
        [form]="form"
        [modelos]="modelos"
        [isModoPadrao]="isModoPadrao">
    </app-regra-tributaria-modelos-documento-section>

    <app-regra-tributaria-observacao-section
        [control]="$any(form.get('observacao'))"
        [variaveis]="variaveisObservacao"
        [isClassificacaoInformada]="isClassificacaoInformada"
        (abrirVariaveis)="abrirVariaveisDisponiveis($event)">
    </app-regra-tributaria-observacao-section>

    <app-regra-tributaria-informacao-fisco-section
        [control]="$any(form.get('informacaoFisco'))"
        [variaveis]="variaveisObservacao"
        [isClassificacaoInformada]="isClassificacaoInformada"
        (abrirVariaveis)="abrirVariaveisDisponiveis($event)">
    </app-regra-tributaria-informacao-fisco-section>
</div>
